import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import { BUSINESS_ADDRESS } from '../constants';

export const useGetBillingAddress = () => {
  const {
    billingAddress = {},
    businessAddress = {},
    selectedBillingAddress,
  } = useSelectPlanCheckoutContext() || {};

  return selectedBillingAddress === BUSINESS_ADDRESS
    ? businessAddress
    : billingAddress;
};
